// Libraries
import Router from 'next/router';

/* Utils */
import { isBrowser } from '@utils/environment';

const RedirectPage = () => {
  /* IF we cannot derive any local data, lets redirect to /us */
  if (isBrowser()) {
    Router.push('/us');
  }

  return null;
};

export default RedirectPage;
